import React, { forwardRef } from 'react'
import TextareaAutosize from 'react-textarea-autosize'

type Props = {
    field: any
    form: any
    autoFocus?: boolean
}

export const ResizeableTextarea = forwardRef<HTMLTextAreaElement, Props>(({ field, form, ...restProps }, ref) => {
    // To ensure the submitted values are trimmed, we'll override Formik's onBlur handler
    function handleBlur(event: React.FocusEvent<HTMLTextAreaElement>) {
        const trimmedValue = event.target.value.trim()

        if (trimmedValue !== field.value) {
            form.setFieldValue(field.name, trimmedValue)
        }

        field.onBlur(event)
    }

    return (
        <TextareaAutosize
            ref={ref}
            name={field.name}
            autoFocus={restProps?.autoFocus}
            minRows={field.minRows || 4}
            maxRows={field.maxRows || 40}
            value={field.value}
            onChange={field.onChange}
            onBlur={handleBlur}
            className={field.className}
        />
    )
})
